import ShowChartIcon from '@material-ui/icons/ShowChart';

import { NeedOfWorkforceList } from './List/List';


export const laborForecastResource = {
	list: NeedOfWorkforceList,
	icon: ShowChartIcon,
};
